// extracted by mini-css-extract-plugin
export default {"layoutMain":"MainLayout_layoutMain__AYVMK","layoutMainNoPadding":"MainLayout_layoutMainNoPadding__b2H4F"};